export default "__VITE_ASSET__ccf72b4e__"